"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bootstrap5_1 = require("./templates/bootstrap5");
exports.default = {
    framework: 'bootstrap5',
    templates: {
        bootstrap5: bootstrap5_1.default
    },
};
